import { createContext, useContext, ReactNode } from 'react';

export type UserContextType = {
  userId?: string;
  isSubscribed: boolean;
  subscriptionExpiresAt?: string;
  isLoading: boolean;
  isAdmin: boolean;
};

const UserContext = createContext<UserContextType | undefined>(undefined);

export function UserProvider({ 
  children, 
  initialData 
}: { 
  children: ReactNode; 
  initialData?: UserContextType 
}) {
  // No need for queries since we're using the session data directly
  const value: UserContextType = {
    userId: initialData?.userId,
    isSubscribed: initialData?.isSubscribed ?? false,
    subscriptionExpiresAt: initialData?.subscriptionExpiresAt,
    isLoading: false,
    isAdmin: initialData?.isAdmin ?? false,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

export function useUser() {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
}
